module.exports = __webpack_public_path__ + "static/media/boris_cherny.ae59db76.jpeg";